 import { Pipe, PipeTransform } from "@angular/core";
 
 @Pipe({
    name: 'getCreditCardIconSrc',
    standalone: true
 })

export class GetCreditCardIconSrcPipe implements PipeTransform {
    transform(cardType: string | undefined, flow?: 'MOVEL' | 'BOLETO_CARTAO' | undefined): string {
        if ((!cardType && !flow) || (!cardType && flow === 'BOLETO_CARTAO')) {
            return 'assets/images/billet.svg';
        } 
        if (!cardType && flow === 'MOVEL') {
            return 'https://mondrian.claro.com.br/brands/app/72px-default/claro-movel.svg';
        }

        switch (cardType?.toLowerCase()) {
            case 'visa':
                return 'assets/images/credit-cards/visa.svg';
            case 'mastercard':
            case 'master':
                return 'assets/images/credit-cards/mastercard.svg';
            case 'american express':
            case 'amex':
                return 'assets/images/credit-cards/amex.svg';
            default:
                return 'assets/images/billet.svg';
        }
    }
}